import React, { useState } from "react";
import { Box, Typography, Snackbar, SnackbarContent } from "@material-ui/core";
import SchoolTable from "./components/SchoolTable";
import PageAccessSettingsButton from "../../access-control/PageAccessSettingsButton";
import "./_centre-management.css";
import "./school-management.css";

const SchoolManagement: React.FC = () => {
  const [alert, setAlert] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
  }>({ open: false, message: "", severity: "info" });

  const handleAlert = (message: string, severity: "success" | "error" | "info" | "warning" = "info") => {
    setAlert({ open: true, message, severity });
  };

  const getAlertColor = (severity: string) => {
    const colors: Record<string, string> = { success: "#4caf50", error: "#f44336", info: "#2196f3", warning: "#ff9800" };
    return colors[severity] || "#2196f3";
  };

  return (
    <>
      <Box className="centre-mgmt-root school-mgmt-root" p={3}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
          <Typography variant="h4" style={{ margin: 0 }}>
            School Management
          </Typography>
          <PageAccessSettingsButton pageKey="school-management" />
        </div>

        <SchoolTable onAlert={handleAlert} />
      </Box>
      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={() => setAlert({ ...alert, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <SnackbarContent
          style={{ backgroundColor: getAlertColor(alert.severity) }}
          message={alert.message}
        />
      </Snackbar>
    </>
  );
};

export default SchoolManagement;
